import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import styled from 'styled-components';

export interface LabelType1Props {
  labelValue: string;
}

const LabelType1 = ({ labelValue }: LabelType1Props) => {
  return (
    <>
      {labelValue === '정상' && <Label1Typel>정상</Label1Typel>}
      {labelValue === '통신이상' && <Label1Type4>통신이상</Label1Type4>}
      {labelValue === '센서이상' && <Label1Type4>센서이상</Label1Type4>}
    </>
  );
};

export default LabelType1;

export const Label1Type = styled.span`
  display: inline-block;
  box-sizing: border-box;
  padding: 10px 16px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
`;

export const Label1Typel = styled(Label1Type)`
  color: #32a877;
  background-color: #cff7e9;
`;

export const Label1Type2 = styled(Label1Type)`
  color: #e16119;
  background-color: #fdeed8;
`;

export const Label1Type3 = styled(Label1Type)`
  color: #e83a32;
  background-color: #feeae9;
`;

export const Label1Type4 = styled(Label1Type)`
  color: #e83a32;
  background-color: #feeae9;
`;
